import React, {Component, Fragment} from "react";
import ApiService from "../../ApiService";
import {IMessageBarHelper} from "../../../utils/IMessageBarHelper";
import {CommandBarButton, Dropdown, Toggle} from "office-ui-fabric-react";
import {
    BulkComparisonScenario,
    BulkProcessorComparisonInput
} from "../../../models/bulk-processor-comparison/BulkComparisonInput";
import {MisName} from "../../../models/MisName";
import {MisDataServiceTypes} from "../../../models/SchoolMailroomConfigDto";

export interface NewBulkComparisonCardProps {
    apiService: ApiService;
    messageBar: IMessageBarHelper;
    
    onTriggered: () => void;
}

export interface NewBulkComparisonCardState
{
    input: BulkProcessorComparisonInput;
    loading: boolean;
}


export class NewBulkComparisonCard extends Component<NewBulkComparisonCardProps, NewBulkComparisonCardState> {

    constructor(props: NewBulkComparisonCardProps) {
        super(props);

        this.state = {
            loading: false,
            input: {
                scenario: BulkComparisonScenario.standard,
                targetMisDataServiceType: MisDataServiceTypes.Arbor,
                misName: MisName.arbor,
                reloadConfig: false
            }
        };
    }

    public async componentDidMount() {
    }

    public componentDidUpdate(prevProps: Readonly<NewBulkComparisonCardProps>, prevState: Readonly<NewBulkComparisonCardState>, snapshot?: any) {
    }

    triggerComparison = async () =>
    {
        this.setState({
            loading: true
        });

        try
        {
            const newInstance = await this.props.apiService.triggerMailroomBulkProcessorComparison(this.state.input);

            this.props.messageBar.success(`Started bulk processor comparison with id : ${newInstance.durableFunctionInstanceId}`);

            this.setState({
                loading: false
            });

            this.props.onTriggered();

        }
        catch (e)
        {
            console.log(e);
            this.props.messageBar.error(`Failed to start bulk processor comparison instances : ${e}`);
            this.setState({
                loading: false
            })
        }
    }
    
    
    private setInput(patch: Partial<BulkProcessorComparisonInput>)
    {
        const newInput = Object.assign({},this.state.input,patch);
     
        this.setState({
            input: newInput
        });
    }
    
    private renderOptionsForScenario(scenario: BulkComparisonScenario)
    {
        const reloadConfig = (
            <Toggle label={"Reload config"} checked={this.state.input.reloadConfig} onChange={(e, isChecked) => {
                this.setInput({
                    reloadConfig: isChecked as boolean
                });
            }} />
        );
        
        const targetMisDataServiceType = (
            <Dropdown
                label={"Data Service Type"}
                selectedKey={this.state.input.targetMisDataServiceType}
                options={[
                    {key: MisDataServiceTypes.Arbor,text: MisDataServiceTypes.Arbor},
                ]}
                onChange={(e,option) => {
                    this.setInput({targetMisDataServiceType: option?.key as MisDataServiceTypes});
                }}
            />
        );

        const misName = (
            <Dropdown
                label={"Mis"}
                selectedKey={this.state.input.misName}
                options={[
                    {key: MisName.arbor,text: MisName.arbor},
                ]}
                onChange={(e,option) => {
                    this.setInput({misName: option?.key as MisName});
                }}
            />
        );
        
        switch (scenario)
        {
            case BulkComparisonScenario.standard:
                return (
                    <Fragment>
                        {reloadConfig}
                    </Fragment>
                );
            case BulkComparisonScenario.directIntegration:
                return (
                    <Fragment>
                        {targetMisDataServiceType}
                        {misName}
                    </Fragment>
                );
        }
        
    }
    

    public render()
    {
        return (
              <div className={"card"}>
                  
                  <div className={"card__header"}>
                      <span className={"card__title"}>New Bulk Comparison</span>

                      <CommandBarButton
                          iconProps={{ iconName: "play" }}
                          text="Start New Comparison"
                          disabled={this.state.loading}
                          onClick={this.triggerComparison}
                      />
                  </div>
                  
                  
                  <div className={"card__content"}>
                      
                      <Dropdown
                          selectedKey={this.state.input.scenario}
                          options={[
                              {key: BulkComparisonScenario.standard,text: BulkComparisonScenario.standard},
                              {key: BulkComparisonScenario.directIntegration,text: BulkComparisonScenario.directIntegration},
                          ]}
                          onChange={(e,option) => {
                              this.setInput({scenario: option?.key as BulkComparisonScenario});
                          }}
                      />
                      
                      {this.renderOptionsForScenario(this.state.input.scenario)}    
                      
                  </div>
                  
              </div>
        );
    }
}